import React, { useEffect } from 'react';
import {
  arrayOf, bool, func, number, oneOfType, shape, string
} from 'prop-types';
import { Checkbox } from '@thd-olt-component-react/checkbox';
import * as analytics from '../../ratings-reviews-analytics';
import './Filter.styles.scss';

export const Filter = ({ onChange, ratingFilters, reviewStatistics }) => {

  useEffect(() => {
    // initialize filter counts from distributions
    const { ratingDistribution, verifiedPurchaserStats } = reviewStatistics;
    ratingFilters.find((rf) => rf.id === 'verified').count = Number(verifiedPurchaserStats);
    ratingDistribution.forEach((rating) => {
      ratingFilters.find((rf) => rf.value === rating.ratingValue.toString()).count = rating.count;
    });
  }, [reviewStatistics]);

  const verifiedCheckbox = ratingFilters.find((checkbox) => checkbox.id === 'verified');

  return (
    <div className="ratings-reviews__review-filter">
      <Checkbox
        key={verifiedCheckbox.id}
        id={verifiedCheckbox.id}
        onChange={() => onChange('verified')}
        checked={verifiedCheckbox.checked}
        value={verifiedCheckbox.value}
        disabled={!verifiedCheckbox.count}
      >
        <div className="ratings-reviews__review-filter_title">
          Verified Purchase ({parseInt(verifiedCheckbox.count) || 0})
        </div>
      </Checkbox>
    </div>
  );
};

Filter.displayName = 'RatingsAndReviewsFilter';

Filter.propTypes = {
  onChange: func.isRequired,
  ratingFilters: arrayOf(shape({
    checked: bool,
    id: string,
    value: oneOfType([number, string]),
    count: number
  })),
  reviewStatistics: shape({
    ratingDistribution: arrayOf(shape({
      ratingValue: number,
      count: number,
      ratingPercentage: oneOfType([number, string])
    })),
    verifiedPurchaserStats: number
  }).isRequired
};
